import React from 'react'
import ReactNative from 'react-native'

export function playSound(type) {}
